/*jslint es6 */
/* eslint-disable import/prefer-default-export */
const ARTICLE_COUNTER_KEY = 'ASReadList';
const LOGIN_SUCCESS_KEY = 'LoggedInFromBlocker';

export function getItemFromLocalStorage() {
  try {
    let data = [];
    if (
      typeof window !== 'undefined' &&
      typeof window.localStorage !== 'undefined'
    ) {
      const values = window.localStorage.getItem(ARTICLE_COUNTER_KEY);
      const parsedValues = JSON.parse(values);
      data = parsedValues || {};
    }

    return data;
  } catch (e) {
    return {};
  }
}

function setItemInLocalStorage(data) {
  // Object structure: { items: [], created: dateInMillis }
  try {
    if (
      typeof window !== 'undefined' &&
      typeof window.localStorage !== 'undefined'
    ) {
      window.localStorage.setItem(ARTICLE_COUNTER_KEY, JSON.stringify(data));
    }
  } catch (e) {
    // console.log(e);
  }
}

function resetLocalStorageObj() {
  const currentDate = new Date().getTime();
  setItemInLocalStorage({ items: [], created: currentDate });
}

function getItemCountFromLocalStorage(resetDays) {
  // Object structure: { items: [], created: dateInMillis }
  try {
    let count = 0;
    const currentDate = new Date().getTime();
    const millisInOneDay = 24 * 60 * 60 * 1000;
    if (typeof window !== 'undefined') {
      const parsedValues = getItemFromLocalStorage();
      if (typeof parsedValues === 'object') {
        if (
          resetDays &&
          typeof resetDays === 'number' &&
          (!parsedValues.created ||
            (currentDate - parsedValues.created) / millisInOneDay > resetDays)
        ) {
          count = 0;
          resetLocalStorageObj();
        } else {
          count =
            parsedValues.items && parsedValues.items.length > 0
              ? parsedValues.items.length
              : 0;
        }
      }
    }
    return count;
  } catch (e) {
    return 0;
    // console.log(e);
  }
}

export function checkIfArticleToShowLimitBreached(count, resetDays) {
  return getItemCountFromLocalStorage(resetDays) >= count;
}

export function addItemToArticleCounter(msid) {
  try {
    if (typeof window !== 'undefined') {
      let itemList = [];
      const parsedValues = getItemFromLocalStorage();
      if (
        typeof parsedValues === 'object' &&
        parsedValues.items &&
        parsedValues.items.length
      ) {
        itemList = parsedValues.items;
      }
      // add only unique msids to read list
      if (itemList.indexOf(msid) === -1) {
        itemList.push(msid);
        parsedValues.items = itemList;
        setItemInLocalStorage(parsedValues);
      }
    }
  } catch (e) {
    // console.log(e);
  }
}

export function isFromDirectSource(query) {
  const { domain, referrer } = document;
  if (
    (referrer === '' && !query.utm_source) ||
    (referrer.length > 0 && referrer.indexOf(domain) !== -1)
  ) {
    return true;
  }

  return false;
}

export function setLoginSuccessInSessionStorage() {
  try {
    if (
      typeof window !== 'undefined' &&
      typeof window.sessionStorage !== 'undefined'
    ) {
      window.sessionStorage.setItem(LOGIN_SUCCESS_KEY, 1);
    }
  } catch (e) {
    // console.log(e);
  }
}
